export * from 'server/models/Organization';


// WEBPACK FOOTER //
// ./data/models/Organization.ts